import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Puzzle} from './puzzle.js';
import {MusicDirector} from './music-director.js';
import {Sounds} from '../enums/Sounds.js';
import {RNG} from '../utils/rng.js';
import {AudioDirector} from './audio-director.js';

export enum Urgency {
    Normal,
    Urgent,
}

export class SegmentedMusicPlayer extends Component {
    static TypeName = 'segmented-music-player';

    // Singleton
    private static _instance: SegmentedMusicPlayer;
    private _currentTrack: Sounds;
    static get instance(): SegmentedMusicPlayer {
        return SegmentedMusicPlayer._instance;
    }

    private _selectedTrack: Sounds = Sounds.none;
    private _tracks = [
        Sounds.Song1Slow,
        Sounds.Song3Slow,
        Sounds.Song4Slow,
        Sounds.Song5Slow,
    ];

    private _urgent = Sounds.Song1And2Fast;
    private _currentUrgency: Urgency = Urgency.Normal;

    private _transitionToUrgentSound = Sounds.TransitionToUrgent;
    private _transitionToNormalSound = Sounds.TransitionToNormal;

    init() {
        if (SegmentedMusicPlayer._instance) {
            console.error(
                'There can only be one instance of SegmentedMusicPlayer Component'
            );
        }
        SegmentedMusicPlayer._instance = this;
    }

    start() {
        //if (this._tracks.length > 0) {
        Puzzle.instance.registerNewGameCallback(this._onNewGame);
        Puzzle.instance.registerGameOverCallback(this._onGameOver);
        //}
        this._currentUrgency = Urgency.Normal;
    }

    setUrgency(urgency: Urgency) {
        if (this._currentTrack != Sounds.none && urgency != this._currentUrgency) {
            let transitionSound = this._transitionToUrgentSound;
            if (urgency == Urgency.Normal) {
                transitionSound = this._transitionToNormalSound;
            }

            if (MusicDirector.instance.musicEnabled) {
                AudioDirector.instance.playOneShotWithPriority(transitionSound);
            }
            MusicDirector.instance.stopImmediate(this._currentTrack);

            switch (urgency) {
                case Urgency.Normal:
                    MusicDirector.instance.play(this._selectedTrack);
                    this._currentTrack = this._selectedTrack;
                    break;

                case Urgency.Urgent:
                    MusicDirector.instance.play(this._urgent);
                    this._currentTrack = this._urgent;
                    break;
            }

            this._currentUrgency = urgency;
        }
    }

    private _onNewGame = (_: Puzzle) => {
        this._selectedTrack = RNG.getItem(this._tracks);
        this._currentTrack = this._selectedTrack;
        this._currentUrgency = Urgency.Normal;
        MusicDirector.instance.play(this._selectedTrack);
    };

    private _onGameOver = (_: Puzzle) => {
        MusicDirector.instance.stopImmediate();
        this._currentTrack = null;
    };
}
